export default __webpack_public_path__ + "static/media/4332832.04cb146c.png";